import { render } from "./AngledBackground.vue?vue&type=template&id=5d475a76&scoped=true"
import script from "./AngledBackground.vue?vue&type=script&lang=js"
export * from "./AngledBackground.vue?vue&type=script&lang=js"

import "./AngledBackground.vue?vue&type=style&index=0&id=5d475a76&scoped=true&lang=css"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d475a76"]])

export default __exports__